export default {
  onboarding: {
    welcome: {
      title: "Bienvenido a",
      subtitle: "Tu app de referencia para investigar apuestas deportivas en props, parlays y principales tendencias. Es hora de subir de nivel.",
      headline: "Encuentra tu próxima apuesta",
      secondaryCta: "¿Ya tienes una cuenta? Inicia sesión",
    },
    leagues: {
      title: "Elige tus ligas favoritas",
      subtitle: "Ve primero las ligas que más te importan cada vez que abras la app.",
    },
    location: {
      title: "Mira qué está disponible cerca de ti",
      subtitle: "Activa la ubicación para ver qué operadores y ofertas están disponibles en tu zona.",
      allowLocationSharing: "Permitir compartir ubicación",
      orSelectRegion: "o selecciona tu región",
    },
    providers: {
      title: "Elige tus operadores",
      subtitle: "Elige tus operadores para recibir tendencias y cuotas personalizadas, y una experiencia de betslip más fluida.",
      emptyCta: "Aún no tengo uno",
    },
    odds: {
      title: "Elige tu formato de cuotas",
      subtitle: "Ve las cuotas en el formato con el que te sientas más cómodo para decidir más rápido y mejor.",
    },
    socialProof: {
      title: "Con la confianza de apostadores de todas partes",
      subtitle: "Desde usuarios nuevos hasta apostadores diarios, Linemate ofrece mejores insights a escala",
      reviewer: "Usuario del App Store",
      reviews: {
        review1: {
          title: "Sinceramente, la app mejor diseñada que he visto en mucho tiempo.",
          text: "Todo está exactamente donde debe estar, las funciones de cada selección trabajan como se espera. Es una app con muchísima información, pero aun así se siente eficiente y muy bien organizada. Como fanático de las estadísticas, felicito a Linemate por el diseño de su app y lo fácil que es encontrar picks seguros."
        },
        review2: {
          title: "La mejor app de todas",
          text: "Esta es 100% la mejor app para apuestas deportivas... después de probarla unos días quedé convencido. Recomiendo mucho la versión paga para tener acceso completo a todo lo que ofrece... no te vas a arrepentir. Descárgala con confianza y disfrútala."
        },
        review3: {
          title: "La mejor",
          text: "He probado muchas apps de estadísticas. Linemate es a la que siempre vuelvo. Ofrecen más gratis que las demás, siguen agregando funciones sin quitar nada, y el plan Plus vale totalmente la pena. El soporte me respondió en 5 minutos. De verdad se nota que quieren ser la app de referencia. Muy recomendada."
        },
        review4: {
          title: "Gratamente sorprendido",
          text: "Si eres nuevo y sigues props a ciegas, los resultados van a variar; igual necesitas estrategia. Descargué Linemate después de que mis parlays siempre fallaban por poco, y mi primer parlay de 7 props de jugador pegó. Por $10 al mes, con una primera semana gratis, vale muchísimo la pena. No será perfecta, pero hace gran parte del trabajo pesado."
        },
        review5: {
          title: "¡Gran app!",
          text: "Ninguna app de apuestas es 100% perfecta, pero esta me ha dado los mejores resultados hasta ahora. Todo está basado en estadísticas y datos reales. La versión gratis ya es sólida, y la suscripción es aún mejor; fácilmente puedes recuperar lo que cuesta con esta app."
        },
        review6: {
          title: "Gran app que realmente destaca",
          text: "Gran app que realmente destaca, accesible y con funciones fuertes para investigar. En general, un trabajo increíble, sigan así."
        },
      },
    },
    summary: {
      title: "Tu perfil está listo",
      subtitle: "Personalizamos la app según tus elecciones. Crea tu perfil para guardarlo y empezar.",
      leagues: "Tus ligas",
      location: "Tu ubicación",
      oddsFormat: "Tu formato de cuotas",
      operators: "Tus operadores",
      noOperators: "Sin operadores",
    },
    consent: {
      title: "Mantente al día",
      subtitle: "Recibe actualizaciones sobre funciones, mejoras y ofertas. Puedes darte de baja en cualquier momento.",
      emailToggle: "Recibe actualizaciones y ofertas exclusivas por correo",
      pushToggle: "Activa notificaciones para insights en tiempo real",
      confirm: "Confirmar mis elecciones",
    },
  },
};